<div fxFlex="column" class="diagnostic-list-dialog">

  <div class="dialog-header">
      Select Diagnostic for {{ title }}
  </div>

  <div class="diagnostic-list-container" fxLayout="column">
    <div *ngIf="diagnosticsListLoading" class="spinner-wrapper">
      <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
    </div>

    <div *ngIf="!diagnosticsListLoading" class="form-field" fxLayout="row" fxLayoutAlign="space-around center">
      <mat-form-field appearance='outline'>
          <mat-label >Select Diagnostic</mat-label>
          <input  type="text" placeholder="Ex. Algebra III" matInput [formControl]="diagnosticsSelectControl" [matAutocomplete]="diagnostic">
          <mat-autocomplete #diagnostic="matAutocomplete" (optionSelected)="setDimDistrictExamID($event.option.id)">
              <mat-option *ngFor="let diagnostic of filteredDiagnostics | async" [value]="diagnostic.ExamDesc" [id]="diagnostic.DimDistrictExamID">
                  {{ diagnostic.ExamDesc }}
              </mat-option>
          </mat-autocomplete>
          <span mat-icon-button matSuffix (click)="clearDiagnosticValue()">
              <mat-icon class="clear-icon">{{ diagnosticsSelectControl.value?.length ? 'highlight_off': ''}}</mat-icon>
            </span>
      </mat-form-field>
    </div>

      <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
          <div>
              <button
                  class="cancel-button button"
                  mat-button
                  type="button"
                  (click)="onCancel()"
              >
                  Cancel
              </button>
          </div>
          <div>
              <button
              class="submit-button button"
              mat-button
              type="button"
              (click)="onSubmit()"
          >
              Submit
          </button>
          </div>
      </div>
  </div>
</div>
